import { PAGE_TYPES } from '@dashboard/enums/page-types';

// The same placement, and the same product, is an order bump on a checkout
// and an add-on on an event. Everything the editor says about one picks its
// noun here, so the two never drift apart.
export const ORDER_BUMP_COPY = {
  noun: 'order bump',
  plural: 'order bumps',
  Noun: 'Order bump',
  Plural: 'Order bumps',
  currencyOwner: 'primary product',
};

export const ADD_ON_COPY = {
  noun: 'add-on',
  plural: 'add-ons',
  Noun: 'Add-on',
  Plural: 'Add-ons',
  currencyOwner: 'event',
};

export const getOfferCopy = page =>
  page?.type === PAGE_TYPES.EVENT ? ADD_ON_COPY : ORDER_BUMP_COPY;
